/* eslint-disable */
export default {
  pages: {
    key: "title",
    data: [
      {title: 'Home',   url: '/',      icon: 'HomeIcon', is_bookmarked: false},
      {title: 'Page 2', url: '/page2', icon: 'FileIcon', is_bookmarked: false},
    ]
  }, 
  clientes: {
    key: 'names_client', 
    data: [
      {
        avatar_profile_image_user: null,
        birthdate_client: null,
        email_user: "usuariopremium@coyag.es",
        family_members_client: null,
        flag_login_user: 1,
        home_address_client: null,
        id_client: 1,
        id_country: 3,
        id_first_nationality: 3,
        id_second_nationality: 2,
        id_titulation: 1,
        id_user: 44,
        landline_client: null,
        name_first_nationality: "Albania",
        name_titulation: "Sin titulación",
        names_client: "Cliente",
        observation_flag_login_user: null,
        office_address_client: null,
        original_profile_image_user: null,
        phone_mobile_client: "+585654611",
        phone_office_client: null,
        roles: [{id_role: 40, name_role: "Usuario Premium mayor 6 meses"}],
        surnames_client: "Premium",
        thumbnail_profile_image_user: null,
        username_user: null,
        verified_email_user: 1,
        working_years_client: null,
      }
    ]
  }
}
/* eslint-enable */
